@if (productId()) {
    <app-product-disposition-overview-panel [productId]="productId()!" />
}
